import Model from './Model';

export default class AppraisalKit extends Model {
    resource () {
        return 'appraisal-kits';
    }
}
